export default __webpack_public_path__ + "static/media/setting_inactive.ba3f9959.svg";